import { useEffect, useRef, useState } from 'react';

declare global {
  interface Window {
    grecaptcha: any;
    onRecaptchaLoad: () => void;
  }
}

export function useRecaptcha(containerId: string) {
  const [token, setToken] = useState<string | null>(null);
  const widgetIdRef = useRef<number | null>(null);

  useEffect(() => {
    const siteKey = '6Ld29LotAAAAAKGVAUs2E9Km7tCo_u_p9alH0zTK';
    let interval: ReturnType<typeof setInterval> | null = null;

    const render = () => {
      const container = document.getElementById(containerId);
      if (!container || widgetIdRef.current !== null) return;
      widgetIdRef.current = window.grecaptcha.render(container, {
        sitekey: siteKey,
        callback: (t: string) => setToken(t),
        'expired-callback': () => setToken(null),
      });
    };

    const tryRender = () => {
      // Poll until both grecaptcha is ready AND the container div is in the DOM
      if (window.grecaptcha && window.grecaptcha.render && document.getElementById(containerId)) {
        render();
      } else {
        interval = setInterval(() => {
          if (window.grecaptcha && window.grecaptcha.render && document.getElementById(containerId)) {
            clearInterval(interval!);
            interval = null;
            render();
          }
        }, 100);
      }
    };

    if (document.getElementById('recaptcha-script')) {
      tryRender();
    } else {
      window.onRecaptchaLoad = tryRender;
      const script = document.createElement('script');
      script.id = 'recaptcha-script';
      script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    return () => {
      if (interval) clearInterval(interval);
      if (widgetIdRef.current !== null && window.grecaptcha) {
        try { window.grecaptcha.reset(widgetIdRef.current); } catch {}
        widgetIdRef.current = null;
      }
      setToken(null);
    };
  }, [containerId]);

  const reset = () => {
    if (widgetIdRef.current !== null && window.grecaptcha) {
      window.grecaptcha.reset(widgetIdRef.current);
    }
    setToken(null);
  };

  return { token, reset };
}
